import _ from 'lodash'
export function storePref(key, value) {
	// get current prefs
	let current = localStorage.getItem('pref') ? localStorage.getItem('pref') : {}
	//console.log(current)
	if(!_.isEmpty(current)) {
		current = JSON.parse(current)
	}
	current[key] = value

	localStorage.setItem('pref', JSON.stringify(current))
}

export function checkPref(key) {
	let current = localStorage.getItem("pref") ? localStorage.getItem("pref") : false

	if(current) {
		let parsed = JSON.parse(current)
		if(parsed[key]) {
			return parsed[key]
		}
	}

	return false
}

export function removePref(key) {
	// get current prefs
	let current = localStorage.getItem("pref") ? JSON.parse(localStorage.getItem("pref")) : {}
	delete current[key]

	localStorage.setItem("pref", JSON.stringify(current))
}